
import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
  name: "AudioClip",
  props: {
    id: String,
    loop: Boolean,
  },
  data() {
    return {
      uniqueId: uuidv4(),
    };
  },
  mounted() {
    const vid = document.getElementById(this.uniqueId) as HTMLAudioElement;
    vid.volume = 0.25;
  },
  computed: {
    AudioClipSource: {
      cache: false,
      get(): string {
        return process.env.BASE_URL + this.id + ".mp3";
      },
    },
  },
});
